import { HorseName, normalTokensIcons } from '../racing-game/consts.ts';


export const coinSelectItems = (
  Object.entries(normalTokensIcons) as [HorseName, string][]
).map(([name, icon]) => [name, { icon }] as const);

// export const defaultCoinSelectedItem = coinSelectItems[0][0] as HorseName;

export const multipliersRatios = [0.7, 0.2, 0.1] as const;
